<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
export default {
  name: 'App',
  mounted() {
    // let script = document.createElement('script');
    // script.type = 'text/javascript';
    // script.src = `https://api.tianditu.gov.cn/api?v=4.0&tk=${'18111c7ecf3f616faf921e930914e879'}`;
    // document.body.appendChild(script)
    const userAgent = navigator.userAgent;
    console.log("🚀 ~ window ~ wx:", window.wx)
    console.log("🚀 ~ mounted ~ wx:", wx)
    console.log("🚀 ~ mounted ~ userAgent:", userAgent);
    uni.getEnv(function(res) {
        console.log('当前环境：' + JSON.stringify(res));
    });
    if (/miniProgram/i.test(userAgent) && /micromessenger/i.test(userAgent)) {
      console.log("🚀 ~ mounted ~ userAgent-1:", userAgent)
      wx.config({
        // debug: true, // 调试时可开启
        appId: 'wx253113327026a583', // <!-- replace -->
        timestamp: 0, // 必填，填任意数字即可
        nonceStr: 'nonceStr', // 必填，填任意非空字符串即可
        signature: 'signature', // 必填，填任意非空字符串即可
        jsApiList: ['chooseImage'], // 必填，随意一个接口即可 
        openTagList:['wx-open-launch-weapp'], // 填入打开小程序的开放标签名
      });
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>
